import { Component } from '@angular/core';
import { DashboardType } from '@app/core/enums/dashboard-types.enum';
import { GenericDashboardComponent } from '@app/shared/components/generic-dashboard/generic-dashboard.component';
import { WorkCompAppointmentsService } from '@app/features/workCompDashboard/services/work-comp-appointments.service';
import { Observable } from 'rxjs';
import { NgAppointments } from '@app/shared/interfaces/appointment.interface';
import { AppointmentSearchParams } from '@app/shared/interfaces/appointmentSearchParams.interface';

@Component({
  selector: 'app-work-comp-dashbboard',
  imports: [
    GenericDashboardComponent
  ],
  templateUrl: './work-comp-dashbboard.component.html',
  styleUrl: './work-comp-dashbboard.component.scss'
})
export class WorkCompDashbboardComponent {
  dashboardType = DashboardType.WorkComp;
  patientSearchInputs = { dashboardType: this.dashboardType };
  contactInfoInputs = { dashboardType: this.dashboardType };

  constructor(
    private workCompAppointmentsService: WorkCompAppointmentsService
  ) {}

  fetchAppointments$: (filter: AppointmentSearchParams) => Observable<NgAppointments> = (filter) => this.workCompAppointmentsService.getAppointments$(filter);
}
